import ITheme from '@/interfaces/iTheme';
// import backgroundImageComicBookTheme from '@assets/themes/comicBook/comicBook.svg';
import backgroundImageComicBookTheme from '@assets/themes/comicBook/comicBookNoBorder.svg';

export class ComicBookTheme implements ITheme
{
    static Id = 'comicbook';
    id = ComicBookTheme.Id;

    name = 'Comic Book';

    colors = {
        application: '#553A97', //#051c29
        text: '#FFFFFF',
        confirm: '#ffcc00',
        confirmText: '#000',
        confirmBorder: '#000',
        secondary: '#111111',

        // Challenge card colors
        solved: '#595959',
        locked: '#0009',
        unsolved: '#ffcc00',
        unsolvedText: '#000000',
        noMoreAttempts: '#0009',
        disabled: '#ffcc00',
        disabledText: '#000000',
        disabledIcon: '#8B0000',

        windowBackground: '#0009',
        windowText: '#FFF',
        windowBorder: '#FFFFFF1F',

        tag: '#62B4E4',
        activeTab: '#62B4E4',
        dialogText: '#303030',
        dialogLink: '#553A97',
        dialogSuccessText: '#4CAF50',
        dialogFailureText: '#F44336',
        dialogIcon: '#553A97',
        success: '#4CAF50',
        warning: '#FF9800',

        // Table
        tableHeaderActionButtons: 'white',
        tableHeaderSelectAllButtons: '#62B4E4',

        //settings and bulk select checkboxes 
        checkedFill:'#0A3399',
        settingsInputError: '#E44949',
        settingsInputErrorShadow: '#06143D',

        // focus indicators
        focusVisibleIndicator: '#0A3399',

        // the most common color from the background image with sufficient contrast
        backgroundImageColor: '#0A3399',

        actionButtonBackground: '#0A3399',
        actionButtonText: 'white',
     };

    fontFamily = "Bangers-Regular";
    landingFontFamily = "Bangers-Regular";
    letterSpacing = "0.12em";
    isDark = true;
    backgroundImage = backgroundImageComicBookTheme;
}
